var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4Check(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4382_27912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.006 491.042C103.05 289.904 78 269.261 78 195.34C78 94.0838 157.842 12 256.333 12C354.824 12 434.666 94.0838 434.666 195.34C434.666 269.261 409.616 289.904 274.661 491.042C265.804 504.195 246.861 504.194 238.006 491.042Z",
    fill: "#e69fbd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.255 239.012L192 193.758L207.085 178.673L237.255 208.843L297.595 148.503L312.68 163.588L237.255 239.012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.667 193C138.667 128.198 191.199 75.6665 256 75.6665C320.801 75.6665 373.333 128.198 373.333 193C373.333 257.801 320.801 310.333 256 310.333C191.199 310.333 138.667 257.801 138.667 193ZM256 289C202.981 289 160 246.019 160 193C160 139.981 202.981 96.9998 256 96.9998C309.019 96.9998 352 139.981 352 193C352 246.019 309.019 289 256 289Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4382_27912",
    x: 74,
    y: 12,
    width: 364.666,
    height: 496.907,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4382_27912"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4382_27912",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Check);
export default __webpack_public_path__ + "static/media/4-check.fb3066dfa524cbd76d4e12d4d6936397.svg";
export { ForwardRef as ReactComponent };